import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-3! py-2!" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex flex-row justify-between gap-x-3" }
const _hoisted_4 = { class: "flex flex-row items-end justify-between gap-x-3" }
const _hoisted_5 = { class: "flex flex-col items-start text-sm" }
const _hoisted_6 = { class: "text-wrap" }

import ReferenceStatus from '@/components/references/ReferenceStatus.vue'
import ReferenceTitle from '@/components/references/ReferenceTitle.vue'

interface Props {
  /** The reference item to display */
  item: ReferenceInterface
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'ReferenceDatatableMobileRow'
},
  __name: 'ReferenceDatatableMobileRow',
  props: {
    item: {}
  },
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("td", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ReferenceTitle, {
          title: __props.item.title
        }, null, 8, ["title"]),
        _renderSlot(_ctx.$slots, "badge", { item: __props.item })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "date", {
            date: __props.item.date
          }),
          (__props.item.description)
            ? _renderSlot(_ctx.$slots, "description", {
                key: 0,
                description: __props.item.description
              }, () => [
                _createElementVNode("p", _hoisted_6, _toDisplayString(__props.item.description), 1)
              ])
            : _createCommentVNode("", true),
          _createVNode(ReferenceStatus, {
            status: __props.item.status
          }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "status", {
                status: __props.item.status
              })
            ]),
            _: 3
          }, 8, ["status"])
        ]),
        _renderSlot(_ctx.$slots, "actions", {
          actions: __props.item.actions
        })
      ])
    ])
  ]))
}
}

})